import React, { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import api from "../lib/api";
import { KeyRound, ArrowLeft } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return toast.error("Passwords do not match");
    if (password.length < 6) return toast.error("Password must be at least 6 characters");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please sign in.");
      navigate("/login");
    } catch (err) {
      toast.error(typeof err.response?.data?.detail === "string" ? err.response.data.detail : "Reset failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#050505] px-6">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-3 mb-3"><KeyRound className="text-gold" /><span className="font-serif text-2xl gold-gradient-text">GI</span></div>
        <h1 className="font-serif text-3xl mb-8 text-white">Set a new password</h1>
        {!token ? (
          <p className="text-white/50 font-body">Invalid reset link. <Link to="/login" className="text-gold">Back to sign in</Link></p>
        ) : (
          <form onSubmit={submit} className="space-y-6">
            <input data-testid="reset-password" type="password" required placeholder="New password" value={password} onChange={(e) => setPassword(e.target.value)} className="editorial-input" />
            <input data-testid="reset-confirm" type="password" required placeholder="Confirm password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="editorial-input" />
            <button data-testid="reset-submit" disabled={loading} className="w-full bg-gold text-black text-sm font-semibold uppercase tracking-widest py-4 hover:bg-white transition-colors disabled:opacity-50">
              {loading ? "..." : "Update password"}
            </button>
          </form>
        )}
        <Link to="/login" className="mt-6 inline-flex items-center gap-2 text-white/60 hover:text-gold text-sm"><ArrowLeft size={14} /> Back to sign in</Link>
      </div>
    </div>
  );
}
